// extracted by mini-css-extract-plugin
export default {"entitlementPageParagraph":"Entitlement_entitlementPageParagraph__lNR7X"};